import React from 'react'
import '../components/SocketButton.css'

function SocketButton() {
  return (
    <div className='socketCont'>
        <button
        onClick = {() => {
            window.location.replace("/join-room")
        }}>Chat</button>
    </div>
  )
}

export default SocketButton